import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const Analytics = lazy(() => import('../pages/Analytics'))

export default [
  {
    path: '/analytics',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <Analytics />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
